module.exports = __webpack_public_path__ + "img/title-6.de5ef288.png";